<template>
  <v-menu
    offset-y
    origin="center center"
    :nudge-bottom="10"
    transition="scale-transition"
  >
    <template v-slot:activator="{on}">
      <v-btn
        icon
        large
        text
        v-on="on"
      >
        <v-avatar size="36px">
          <img
            v-if="avatar"
            :src="avatar"
            alt="name"
          >
          <v-icon
            v-else
            x-large
            class="blue--text"
          >
            mdi-account
          </v-icon>
        </v-avatar>
      </v-btn>
    </template>
    <v-list class="pa-0" width="250px">
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <img
              v-if="avatar"
              :src="avatar"
              alt="name"
            >
            <v-icon
              v-else
              x-large
              class="blue--text"
            >
              mdi-account
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ user.email }}</v-list-item-title>
            <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <v-list-item
        v-for="(item,index) in menuitems"
        :key="index"
        :to="item.name ? {name: item.name} : null"
        active-class="primary primary--text text--lighten-1"
        rel="noopener"
        @click="item.click"
      >
        <v-list-item-action v-if="item.icon">
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppProfile',
  data() {
    return {
      avatar: '',
      menuitems: [
        {
          icon: 'mdi-account-cog-outline',
          name: 'Settings',
          title: this.$route.meta.type === 'company' ? 'toolbar.companySetting' : 'toolbar.settings',
          click: () => {
            console.log('this.toggleSettingsPanel()');
          },
        },
        {
          icon: 'mdi-exit-to-app',
          title: 'toolbar.logout',
          click: () => {
            this.logout();
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'user',
    ]),
  },
  methods: {
    logout() {
      if (Object.keys(this.$route.params).length == 0 && this.$route.name === 'Settings' && this.$route.meta.logout || Object.keys(this.$route.params).length == 0 && this.$route.name !== 'Settings') {
        this.$store.dispatch('GetUpdateUser', this.user.id).then(() => {
          this.$store.dispatch('LogOut');
          this.$router.push({ name: 'login' });
        })
      } else {
        if (this.$route.name === 'CompanyAction') {
          this.$store.dispatch('GetUpdateUser', this.user.id).then(() => {
            this.$store.dispatch('LogOut');
            this.$router.push({ name: 'login' });
          })
        }
        this.$store.commit('SET_USER_LOGOUT', true)
      }
    }
  },
};
</script>
